<template>
    <div class="content-lib-elements">
        <div id="contentMenu">
            <div id="searchInputWrapper" class="flexContainer ai-c jc-sb">
                <input id="searchInput" class="full" type="search" v-model="nameFilter" :placeholder="$t('common.search')" />
                <div class="ai-c">
                    <img @click="nameFilter = '';" id="cross" src="../../../assets/cross.png" alt width="10" height="10" class="cross pointer" />
                </div>
            </div>
            <div id="buttons" class="buttonsDiv">
                <button
                    class="buttonLibrary uppercase"
                    v-for="type in componentType"
                    @click="setFilterType(type.type);"
                    :key="type.type"
                    :id="type.type"
                    :class="{ active: typeFilter === type.type }"
                >
                    {{ type.name }}
                </button>
            </div>
            <CategoryFilters />
            <section id="content">
                <transition-group name="fade" id="resultsWrapper" class="flexContainer fw-w scrollY rel">
                    <div v-for="item in elements" :key="item.id" class="item rel size1of3 flexContainer fd-c ai-c jc-fs">
                        <div class="item full center txtCenter">
                            <figure class="rel center">
                                <img
                                    src="../../../../static/img/no_image.jpg"
                                    class="grab img-fluid ff-medium svgMeuble center"
                                    v-if="item.figures.medium === null"
                                />
                                <img
                                    :src="getImgUrl(item)"
                                    class="grab img-fluid ff-medium svgMeuble center"
                                    @mousedown="copyElement($event, item);"
                                />
                            </figure>
                            <div class="flexContainer">
                                <h4 class="ff-bold rel capitalize jc-sb center txtCenter">{{ item.terms.name[$t("trad")].value }}</h4>
                                <img src="../../../assets/link_icon.svg" class="pointer" @click="link(item);" height="15" alt />
                            </div>
                        </div>
                    </div>
                </transition-group>
                <div v-if="elements.length === 0">Aucun composant correspondant au filtre</div>
            </section>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Globals from "../../globals.js";
import { TYPE_DIVIDER, TYPE_SHELF } from "../../../store/catalog/typeStructure";
import CategoryFilters from "./CategoryFilters";

export default {
    props: {
        carcass: { type: Number, default: 0 },
        cluster: { type: Number, default: 0 },
        plano: { type: Number, default: 0 }
    },
    components: {
        CategoryFilters
    },
    data: () => ({
        elementsOrigin: [],
        componentType: [
            { type: "ALL", name: "ALL" },
            { type: "module", name: "MODULE" },
            { type: TYPE_SHELF, name: "SHELF" },
            { type: TYPE_DIVIDER, name: "DIVIDER" }
        ],
        typeFilter: "ALL",
        nameFilter: ""
    }),
    methods: {
        setFilterType(typeFilter) {
            this.typeFilter = typeFilter;
        },
        ...mapActions("events/planomassmarket", {
            dispatchCopyElement: "dispatchCopyElement"
        }),
        link(item) {
            window.open("/" + item.type + "/" + item.id);
        },
        getImgUrl(imgPath) {
            let ret = this._.find(imgPath.figures_advanced, o => o.id_type_file === 6);

            if (typeof ret !== "undefined") {
                return Globals.getBaseUrl() + ret.big;
            } else {
                return "/static/assets/svg/generic_module-01.svg";
            }
        },
        getImgPath(imgPath) {
            let ret = this._.find(imgPath.figures_advanced, o => o.id_type_file === 6);

            if (typeof ret !== "undefined") {
                return ret.big;
            } else {
                return "/static/assets/svg/generic_module-01.svg";
            }
        },
        copyElement(e, data) {
            let cmpData = this.assign(data);
            let obj = { elt: e.target, data: cmpData, event: e };
            this.dispatchCopyElement(obj);
        }
    },
    computed: {
        elements() {
            const filterByType = (typeFilter, elements) => {
                switch (typeFilter) {
                    case "module":
                        return elements.filter(res => res.type === typeFilter);
                    case TYPE_DIVIDER:
                    case TYPE_SHELF:
                        return elements.filter(res => res && res.config && res.config.type === typeFilter);
                    default:
                        return elements;
                }
            };

            const filterByName = (/** @type {string} */ name, /** @type {Component[]} */ elements) => {
                if (!name || name.length === 0) {
                    return elements;
                }
                name = name.toUpperCase();
                return elements.filter(element => {
                    // we get the translated name. Nickname is not enough
                    /** @type {string} */
                    const elementName = this.getTranslate(element.terms.name);

                    return elementName.toUpperCase().includes(name);
                });
            };

            const filterByCategory = (category, elements) => {
                return (
                    (category &&
                        elements.filter(element => {
                            return !!element.infoCategories.categories[category];
                        })) ||
                    elements
                );
            };

            return filterByCategory(this.$route.query.category, filterByName(this.nameFilter, filterByType(this.typeFilter, this.elementsOrigin)));
        },

        ...mapGetters({
            getElementItems: "items/getElementItems"
        })
    },
    created() {
        this.$store
            .dispatch("items/getElementItems", {
                carcass: this.carcass,
                cluster: this.cluster,
                plano: this.plano
            })
            .then(response => response.filter(res => res.is_published === true))
            .then(response => {
                this.elementsOrigin = response;
                this.activeComponent = "tous";
            });
    }
};
</script>
<style lang="scss" scoped>
.active {
    color: #cc0000;
    font-weight: bold;
    transition: all 0.3s;
}

.buttonsDiv {
    text-align: center;
}

.buttonLibrary {
    border: none;
}

.content-lib-elements {
    height: 100%;
    width: 100%;
    border: 1px solid #6f6f6f;
}

.goToCatalogue {
    text-decoration: none;
    color: #000;
    margin: auto;
    font-size: 14px;
    border: 1px solid #cfcfcf;
    padding: 10px 15px;
    .link {
        margin-right: 6px;
    }
}

#contentMenu {
    background: #fff;
    height: 100%;
    overflow: hidden;

    #searchInputWrapper {
        padding: 15px;
        #searchInput {
            height: 30px;
            border-left: none;
            border-top: none;
            border-right: none;
            font-size: 14px;
        }
        #cross {
            position: relative;
            right: 15px;
        }
    }
    #filtersPlano {
        padding: 0 15px;
        .sections {
            padding-left: 0;
            margin-top: 0;
            li {
                background-color: #eeeeee;
                padding: 10px 15px;
                font-size: 14px;
                margin-right: 15px;
                &.active {
                    background-color: #41b4e8;
                    color: #fff;
                    &:after {
                        content: "";
                        position: absolute;
                        bottom: -6px;
                        width: 0px;
                        height: 0px;
                        border-left: 7px solid transparent;
                        border-right: 7px solid transparent;
                        border-top: 7px solid #41b4e8;
                    }
                    &:last-child {
                        margin-right: 15px;
                    }
                }
                &.goToCatalogue {
                    background: #fff;
                }
            }
        }
        .categories {
            padding-left: 0;
            margin-top: 20px;
            li {
                padding: 0 10px;
                font-size: 14px;
                color: #aaa;
                &.active {
                    color: #41b4e8;
                }
            }
        }
        .subCategories {
            padding-left: 0;
            margin-top: 15px;
            li {
                padding: 0 10px;
                color: #aaa;
                font-size: 12px;
                &.active {
                    color: #41b4e8;
                }
            }
        }
    }
    #spinnerLoader {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        z-index: 10;
        .loader {
            margin: auto;
        }
    }
    #content {
        height: calc(100% - 80px);
    }
    #noResults {
        height: 100%;
        h3 {
            margin: auto;
        }
    }
    #resultsWrapper {
        padding: 15px 15px 0px 15px;
        max-height: 100%;
        .item {
            font-size: 12px;
            margin-bottom: 20px;
            .item {
                margin-bottom: 0;
                img {
                    top: 0;
                    right: 10px;
                }
            }
            &.bordered {
                border-right: 1px solid #ccc;
            }
            .svgMeuble {
                padding: 15px;
                width: 200px;
                height: 200px;
            }
            h3 {
                padding: 0 15px;
                margin: 0;
                a {
                    text-decoration: none;
                    color: #343434;
                }
            }
            figure {
                max-width: 100%;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center center;
            }
        }
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    #contentMenu {
        #filtersPlano {
            .sections {
                li {
                    font-size: 1.1rem;
                    padding: 5px 7px;
                    height: 25px;
                    line-height: 15px;
                    img {
                        width: 10px;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Elements.vue?a8fd5f16